<template>
    <div :class="{ 'helpLink': props.link }" @click="openHelpLink(props.link)"
        class="helpContainer px-3 pb-2 elevation-2">
        <div class="helpCard d-flex align-center">
            <img :src="props.icon">
            <p>{{ props.text }}</p>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    icon: { type: String },
    text: { type: String },
    link: { type: String },
})

const openHelpLink = (link) => {
    window.open(link, '_blank')
}
</script>

<style scoped>
.helpContainer {
    padding-top: 32px;
    box-sizing: border-box;
    width: 120px;
    background: rgb(var(--v-theme-neutral-98));
    border-radius: 8px;
    font-size: 14px;
}

.helpCard:after {
    content: '';
    position: absolute;
    left: 25%;
    bottom: 100%;
    width: 50px;
    height: 50px;
    background: #FFF;
    border-radius: 50%;
    z-index: 2;

}

.helpCard {
    position: relative;
    width: 100%;
    height: 100%;
}

.helpCard img {
    position: absolute;
    left: 30%;
    bottom: 110%;
    z-index: 3;
}

.helpCard p {
    margin: 0 auto;
}

.helpLink {
    cursor: pointer;
}
</style>
